<template>
    <div class="questionTransferMain">
        <div class="questionTransferOne" v-for="(g,i) in segment_list" :key="g.name" v-if="i != currentNode[0] && g.questions.length">
            <p class="title">{{getChineseNumber(i)}}、{{g.name}}</p>
            <span v-for="(t,n) in g.questions" :key="t.test_id" @click="addQuestionsTransfer(i,n)" :class="testActive(i,n)">{{setNumber(i,n+1)}}</span>
        </div>
        <el-button size="small" type="primary" @click="transferTestSubmit">确定</el-button>
    </div>
</template>

<script>
import $store from '../store'
import utils from './utils';
export default {
    data(){
        return{
            transferList: [],//转移列表
        }
    },
    methods: {
        getChineseNumber(index){//对应中文数字
            return utils.getChineseNumber(index+1)
        },
        addQuestionsTransfer(index,num){
            let data = index+'-'+num
            let i = this.transferList.indexOf(data)
            if(i > -1){
                this.transferList.splice(i,1)
            }else{
                this.transferList.push(data)
            }
        },
        testActive(i,n){//设置选中class
            if(this.transferList.includes(i+'-'+n)){
                return 'on'
            }
            return ''
        },
        setNumber(index,num){//计算序号
            let sum = 0
            this.assemblyData.segment_list.forEach((el,i)=>{
                if(i>=index){
                    return
                }
                sum += el.questions.length
            })
            sum=sum+num
            return sum
        },
        transferTestSubmit(){//转移提交
            let arr = JSON.parse(JSON.stringify(this.transferList))
            let len = arr.length,i,j,stop;
            for(i=0;i<len; i++){
                for(j=0,stop=len-i;j<stop;j++){
                    if(arr.length != j+1 && Number(arr[j].replace('-',''))<Number(arr[j+1].replace('-',''))){
                        swap(arr,j,j+1);
                    }
                }
            }
            function swap(items, firstIndex, secondIndex){
                let temp = items[firstIndex];
                items[firstIndex] = items[secondIndex];
                items[secondIndex] = temp;
            }
            $store.commit('QUESTIONTRANSFERGROUP',arr)
            $store.commit('SETTRANSFERTESTSHOW')
        },
    },
    computed: {
        assemblyData(){
            return $store.state.assemblyData
        },
        currentNode(){
            return $store.state.currentNode
        },
        segment_list(){
            return $store.state.segment_list
        },
        totalQuestion(){
            return $store.getters.totalQuestion
        }
    }
}
</script>



// WEBPACK FOOTER //
// packages/question-assembly/src/questionTransferEnter.vue